<style lang="scss" scoped>
.payment-code-image {
  max-width: 265px;
}

.invalid-feedback,
.valid-feedback {
  display: block;
}

.btn {
  flex-shrink: 0;
}

.btn-back {
  color: $white;
  background-color: $payment-back-btn-color;
  border-color: $payment-back-btn-border;
}
</style>

<template>
  <div class="p-md-5">
    <div class="pb-2 d-flex flex-wrap justify-content-around">
      <p class="text-center text-xl">
        Geben Sie einen Gutscheincode ein
      </p>
    </div>
    <div class="mx-auto p-3 mb-4 border">
      <p>
        Wenn du einen Gutscheincode besitzt, dann füge ihn einfach unten in das
        Feld ein und klicke auf Einlösen.
      </p>
    </div>
    <div class="d-flex">
      <input
        class="text-xl form-control mr-3"
        v-model="code"
        :disabled="loading"
      />
      <v-button
        class="text-xl btn btn-primary"
        @click.native="redeem"
        :working="loading"
      >
        Einlösen
      </v-button>
    </div>
    <div v-if="error" class="invalid-feedback">
      {{ error }}
    </div>
    <div v-if="successMessage" class="valid-feedback">
      {{ successMessage }}
    </div>
    <div class="row mt-3">
      <div class="col-md-2">
        <button @click="back" type="button" class="w-100 text-xl btn btn-back">
          Zurück
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import PaymentCode from "@/components/payment/PaymentCode";

export default {
  components: {
    PaymentCode
  },
  data() {
    return {
      error: null,
      loading: false,
      successMessage: "",
      code: ""
    };
  },
  computed: {
    appCurrency() {
      return Laravel.lang.currency;
    }
  },
  methods: {
    back() {
      this.$emit("back");
    },
    redeem() {
      this.error = null;
      this.successMessage = "";
      this.loading = true;
      let code = this.code;
      this.$http
        .post("/api/v1/coupon/redeem", { code })
        .then(response => {
          this.successMessage =
            response.data +
            " " +
            this.appCurrency +
            " wurde zu deinem Profil hinzugefügt.";
        })
        .catch(error => {
          this.error = error.response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
